module.exports = "\n<div class=\"dropdown2\" v-el:dropdown :style=\"getStyle()\">\n    <slot></slot>\n</div>\n";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/ui/Dropdown2.vue
// module id = ./node_modules/vue-html-loader/index.js!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/javascript/components/ui/Dropdown2.vue
// module chunks = 54